import React from 'react';

// import default view
import { tooltipMounter as TooltipMounterView } from './tooltipMounter.view';
import { messageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';

// default state
const DEFAULT_STATE = {
    isVisible: false,
    title: undefined,
    text: undefined,
    position: undefined,
};

/*****************************/

/**
 * @type {function}
 * @desc Mount tooltip container to listen to tooltip open/close events.
 * @param {object} Component - A React component
 * @example
 * import { TooltipMounter } from 'modules/tooltip';
 *
 * // render
 * <TooltipMounter propName='propValue'/>
 */
export class TooltipMounter extends React.Component {
    constructor( props ) {
        super( props );

        // bind events and methos
        this.__bind();

        // component state
        this.state = DEFAULT_STATE;

        // timeout id
        this.timeoutId = null;
    }

    /**
     * @desc Bind methods and events to the instance.
     */
    __bind() {
        messageBus.on( MESSAGE_BUS_EVENTS.OPEN_TOOLTIP, this.handleOpen, this );
        messageBus.on( MESSAGE_BUS_EVENTS.CLOSE_TOOLTIP, this.handleClose, this );
        
        this.handleOpen = this.handleOpen.bind( this );
		this.handleClose = this.handleClose.bind( this );
    }

    /***********************************************/

    /**
     * @desc Open tooltip view and update text inside.
     */
    handleOpen( { element = [], title, text } = {} ) {
        log.debug( 'TooltipMounter.handleOpen()' );

        // get elements position relative to viewport (window/canvas)
        const position = element.getBoundingClientRect();

        // start timeout
        this.startTimeout( { position, title, text } );
    }

    /**
     * @desc Close tooltip view and reset component to default state
     */
    handleClose() {
        log.debug( 'TooltipMounter.handleClose()' );

        this.cancelTimeout(); // cancel timeout

        // reset state only if tooltip was visible, else no need
        if( this.state.isVisible ) {
            this.setState( DEFAULT_STATE );
        }
    }

    /**
     * @desc Start timeout to open tooltip after few seconds.
     */
    startTimeout( { position, title, text } ) {
        this.timeoutId = setTimeout( () => {
            this.setState( {
                position,
                title,
                text,
                isVisible: true, // make tooltip visible
            } );
        }, 500 ); // 0.5s delay
    }

    /**
     * @desc Clear timeout.
     */
    cancelTimeout() {
        clearTimeout( this.timeoutId );
    }
    
    /***********************************************/

    /**
     * @desc When component unmounts, cleanup resources.
     */
    componentWillUnmount() {
        this.cancelTimeout(); // cancel timeout
    }

    /**
     * @desc Render tooltip view with inner text.
     */
    render() {

        // return `null` view if tooltip is not visible
        if( ! this.state.isVisible ) {
            return null;
        }

        // return tooltip mounter view
        return (
            <TooltipMounterView { ...this.state } />
        );
    }
}

// set display name
TooltipMounter.displayName = 'TooltipMounter';

// default props
TooltipMounter.defaultProps = {};

// prop types
TooltipMounter.propTypes = {};
